import React from "react";
import { Row } from "react-bootstrap";
import "../../Assets/Styles/pages/landing.scss";
import { useTranslation } from "react-i18next";
import TilesRow from "../Tiles/tiles";
import { MoreFeaturesPricing } from "../../Config/features";

const PriceFeatures = () => {
  const { t } = useTranslation();

  return (
    <Row className="m-0 mt-5 pt-5 w-100 bgPricingFeatures d-flex flex-column justify-content-center align-items-center ">
      <Row className="line_height_100pc pt-2  text-center d-flex justify-content-center align-items-center">
        <p className="m-0 text_36 productSansBold">
          <span>{t("PricingFeaturesTitle1")}</span>
          <span className="mx-0  landing_banner_Heading">
            {t("PricingFeaturesSpan")}
          </span>
          {t("PricingFeaturesTitle2")}
        </p>
      </Row>
      <TilesRow data={MoreFeaturesPricing} />
    </Row>
  );
};

export default PriceFeatures;
